import type { ComponentPublicInstance } from 'vue';
export function mergeRefs(
  ...refs: ((el: Element | ComponentPublicInstance | null) => void | undefined)[]
) {
  return (el: Element | ComponentPublicInstance | null) => {
    for (const r of refs) {
      r?.(el);
    }
  };
}
